import { AccountantTransferPhase } from '@/types'
import { CompanyOpeningStatus, CurrentStep } from '../company-opening-status'
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogProps,
  DialogTitle,
} from '@mui/material'

type AccountantTransferStatusDialogProps = DialogProps & {
  currentStep: CurrentStep
  phases: AccountantTransferPhase[]
  onClose: () => void
}

export function AccountantTransferStatusDialog({
  currentStep,
  phases,
  onClose,
  ...props
}: AccountantTransferStatusDialogProps) {
  return (
    <Dialog {...props} onClose={onClose}>
      <DialogTitle>Status da transferência de contador</DialogTitle>
      <DialogContent>
        <CompanyOpeningStatus currentStep={currentStep} phases={phases} />
      </DialogContent>
      <DialogActions>
        <Button variant="text" onClick={onClose}>
          Fechar
        </Button>
      </DialogActions>
    </Dialog>
  )
}
